import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "16", height: "13", x: "6", y: "4", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 8v11c0 1.1.9 2 2 2h14", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Mails";
const Mails = memo(themed(Icon));
export {
  Mails
};
//# sourceMappingURL=mails.js.map
